const deliveryConfirmationES = {
    "view": {
        "table": {
            "title": "Lista Entregada",
            "columns": {
                "release": "Lanzamiento",
                "upc": "Número UPC",
                "action": "Acción",
                "status": "Estado",
                "deliveryDate": "Fecha de Entrega",
                "details": "Detalles"
            },
            "label": {
                "statusDelivered": "ENTREGADO",
                "statusPartially": "PARCIALMENTE",
                "statusUndelivered": "NO ENTREGADO",
                "ddexActionInsert": "INSERTAR",
                "ddexActionFullUpdate": "ACTUALIZACIÓN COMPLETA",
                "ddexActionMetadataUpdate": "ACTUALIZACIÓN META.",
                "ddexActionTakedown": "RETIRADA"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "button": {
                "open": "ABRIR",
                "exportCSV": "Exportar CSV"
            }
        }
    },
    "breakdownView": {
        "table": {
            "title": "Lista de Entrega de Tienda",
            "column": {
                "store": "Tienda",
                "additionalNote": "Notas Adicionales",
                "status": "Estado"
            },
            "label": {
                "statusDelivered": "ENTREGADO",
                "statusUndelivered": "NO ENTREGADO"
            },
            "button": {
                "exportCSV": "Exportar CSV"
            },
            "message": {
                "appleSubjectToQC": "Entregado con éxito, sujeto a control de calidad adicional por parte del personal de Apple Music.",
                "releaseDeliverySuccessfull": "El lanzamiento ha sido entregado con éxito a los servidores de {{dspName}}",
                "releaseDeliveryUnsuccessfull": "La entrega del lanzamiento no fue exitosa para {dspName}.",
                "noDeliveriesPossible": "No hay entregas posibles en este momento"
            }
        }
    }
};

export default deliveryConfirmationES;